module.exports = __webpack_public_path__ + "img/image 48.3866f6eb.svg";